import { render, staticRenderFns } from "./ButtonPrimary.vue?vue&type=template&id=1a2007e4&scoped=true&"
import script from "./ButtonPrimary.vue?vue&type=script&lang=js&"
export * from "./ButtonPrimary.vue?vue&type=script&lang=js&"
import style0 from "./ButtonPrimary.vue?vue&type=style&index=0&id=1a2007e4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a2007e4",
  null
  
)

export default component.exports